/**
 * Layout templates: slots expressed as fractions (0..1) of the SCOPE box.
 * - scope 'spread': the box is the whole spread (2 × page width by page height).
 * - scope 'page':   the box is one page (left or right); the caller chooses the page.
 * - scope 'cover':  each slot names the cover panel its fractions are of (`panel`); a slot with no
 *                   panel spans the whole strip (front + spine + back). The spine width and the
 *                   binding are per album, so panels — not strip fractions — are what keep a cover
 *                   layout honest.
 * Fractions are converted to mm frames by `materializeLayout` / `materializeCoverLayout` in ./ops.
 */
export interface LayoutSlot {
  id: string;
  kind: 'photo' | 'text';
  x: number;
  y: number;
  w: number;
  h: number;
  /** text slots only: drives the TextElement kind and default typography */
  role?: 'title' | 'caption' | 'body';
  /** cover scope only: the panel the fractions are of; omitted = the whole strip */
  panel?: 'front' | 'back' | 'spine';
}

export type LayoutFamily = 'square' | 'portrait' | 'landscape' | 'panoramic';
export type LayoutScope = 'spread' | 'page' | 'cover';

export interface Layout {
  id: string;
  name: string;
  scope: LayoutScope;
  photoCount: number;
  textCount: number;
  slots: LayoutSlot[];
  /** page-format families this layout looks good in */
  families: LayoutFamily[];
  /** free-form hints, e.g. 'grid', 'hero', 'for-landscape', 'for-portrait', 'title' */
  tags: string[];
  /** outer margin used by the layout, as a fraction of the box (informational) */
  marginFrac?: number;
}
